import React from "react";
import { Stack } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useSelector } from "react-redux";

// * Import kits
import Box from "../../kit/Box";
import Typography from "../../kit/Typography";
import Button from "../../kit/Button";

// * Import assets
import welcomeLogoLight from "../../../assets/images/signup_images/light_theme/welcome_img.svg";
import welcomeLogoDark from "../../../assets/images/signup_images/dark_theme/welcome_img_dark.svg";
import { MESSAGES } from "../../utils/config";
import { getThemeName } from "../../utils/utils";
import UserTour from "../../components/UserTour/UserTour";
import { accountSetupStep1 } from "../../components/UserTour/Data/DiscoverSteps";
// * Import styles
import { welcomeScreenStyles } from "../../theme/style";

// # Component
const WelcomeScreen = ({ templateData, setActiveScreen }) => {
  // # Static Variables
  // const userInfo = useSelector((state) => state.auth.metadata);
  const theme = useTheme();
  const classes = welcomeScreenStyles(theme);
  const isDarkMode = useSelector((state) => state.selections.isDarkMode);
  const userJourney = useSelector((state) => state.auth.userJourney);
  let newUserPageFlag =
    userJourney?.isNewUser && userJourney?.pagesToShow?.["accountSetupWelcome"];
  const welcomeLogo = getThemeName(isDarkMode)
    ? welcomeLogoDark
    : welcomeLogoLight;

  // # JSX
  return (
    <div
      className={classes.setupCardContainer}
      style={{ marginLeft: "6%", height: "100%", display: "flex" }}
    >
      <UserTour
        steps={accountSetupStep1}
        isOpen={userJourney?.showJourney || newUserPageFlag}
        page={"accountSetupWelcome"}
        newUserPageFlag={newUserPageFlag}
      />
      <Box className={classes.container}>
        <Stack style={{ marginBottom: "200px" }}>
          <Typography
            variant="h5"
            style={{
              textTransform: "uppercase",
              fontWeight: theme.fontWeight[800],
              marginTop: "0px",
              marginBottom: "5px",
              fontSize: "28px",
              color: theme.palette.cards.heading,
            }}
          >
            Welcome to {MESSAGES.ART}
          </Typography>
          <Typography
            style={{
              textTransform: "uppercase",
              fontWeight: theme.fontWeight[500],
              marginTop: "0px",
              fontSize: "16px",
              color: theme.palette.cards.heading,
            }}
          >
            {MESSAGES.ART_FULL}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              margin: theme.margin[1],
              fontWeight: theme.fontWeight[400],
              fontSize: "16px",
              width: "90%",
              marginTop: "20px",
              color: theme.palette.cards.heading,
            }}
          >
            {templateData.Description}
          </Typography>
        </Stack>
        <br></br>
        <br></br>
        <Button
          disableRipple
          className={classes.BeginButton}
          onClick={() => setActiveScreen((prev) => prev + 1)}
          style={{
            textTransform: "uppercase",
          }}
          id="journey-begin-button"
        >
          Begin
        </Button>
      </Box>
      <Box sx={{ width: "40%", position: "relative" }}>
        <img
          src={welcomeLogo}
          alt="error"
          style={{ height: "100%", position: "absolute", right: "-60px" }}
        />
      </Box>
    </div>
  );
};

// # Exports
export default WelcomeScreen;
